import React from "react";
import { Box, MainText, PressableOpacity } from "app/components/common";
import theme from "app/Theme/Theme";
import CheckBox from "@react-native-community/checkbox";
import { Platform } from "react-native";
import { isAndroid } from "@microdoing/shared/utils/deviceDetectors";

export interface IOptionBar {
  text: string;
  isSelected: boolean;
  onPress: () => void;
}

const OptionBar = ({ text, isSelected, onPress }: IOptionBar) => {
  return (
    <PressableOpacity
      onPress={onPress}
      style={{
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Box
        flexDirection="row"
        alignItems="center"
        paddingHorizontal="sm"
        paddingVertical="s"
      >
        <CheckBox
          onChange={Platform.OS === "android" ? onPress : () => {}}
          value={isSelected}
          boxType={"square"}
          onAnimationType="fill"
          offAnimationType="fill"
          tintColor={theme.colors["brand.500"]}
          onCheckColor={theme.colors["neutral.white"]}
          onFillColor={theme.colors["brand.500"]}
          onTintColor={theme.colors["brand.500"]}
          style={{ width: 16, height: 16 }}
          color={theme.colors["brand.500"]}
        />
        <MainText
          variant={isSelected ? "l4-bold" : "l4-medium"}
          marginLeft={isAndroid ? "m" : "sm"}
          marginRight="sm"
          color={isSelected ? "brand.500" : "neutral.900"}
        >
          {text}
        </MainText>
      </Box>
    </PressableOpacity>
  );
};

export default OptionBar;
